import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appConfig: null,
    qmUserToken: null,
    memberCoupon: null,
    uuid: null,
    wxid: null,
    refreshChannel: null,
    tfCardKey: null,
    useWallet: false,
  },
  mutations: {
    SET_APP_CONFIG(state, config) {
      state.appConfig = config
    },
    SET_QM_USER_TOKEN(state, qmUserToken) {
      state.qmUserToken = qmUserToken;
    },
    SET_MEMBER_COUPON(state, coupon) {
      state.memberCoupon = coupon;
    },
    SET_UUID(state, uuid) {
      state.uuid = uuid;
    },
    SET_WXID(state, wxid) {
      state.wxid = wxid;
    },
    SET_REFRESH_CHANNEL(state, refreshChannel) {
      state.refreshChannel = refreshChannel;
    },
    SET_TF_CARD_KEY(state, tfCardKey) {
      state.tfCardKey = tfCardKey || null;
    },
    CLEAR_QM_USER_TOKEN(state) {
      state.qmUserToken = null;
    },
    CLEAR_MEMBER_COUPON(state) {
      state.memberCoupon = null;
    },
    CLEAR_UUID(state) {
      state.uuid = null;
    },
    CLEAR_WXID(state) {
      state.wxid = null;
    },
    CLEAR_REFRESH_CHANNEL(state) {
      state.refreshChannel = null;
    },
    CLEAR_TF_CARD_KEY(state) {
      state.tfCardKey = null;
    },
    SET_USE_WALLET(state, useWallet) {
      state.useWallet = !!useWallet;
    },
    CLEAR_USE_WALLET(state) {
      state.useWallet = false;
    },
  },
  actions: {
    setQmUserToken({ commit }, qmUserToken) {
      commit('SET_QM_USER_TOKEN', qmUserToken);
    },
    setMemberCoupon({ commit }, coupon) {
      commit('SET_MEMBER_COUPON', coupon);
    },
    setUuid({ commit }, uuid) {
      commit('SET_UUID', uuid);
    },
    setWxid({ commit }, wxid) {
      commit('SET_WXID', wxid);
    },
    setRefreshChannel({ commit }, refreshChannel) {
      commit('SET_REFRESH_CHANNEL', refreshChannel);
    },
    setTfCardKey({ commit }, tfCardKey) {
      commit('SET_TF_CARD_KEY', tfCardKey);
    },
    clearQmUserToken({ commit }) {
      commit('CLEAR_QM_USER_TOKEN');
    },
    clearMemberCoupon({ commit }) {
      commit('CLEAR_MEMBER_COUPON');
    },
    clearUuid({ commit }) {
      commit('CLEAR_UUID');
    },
    clearWxid({ commit }) {
      commit('CLEAR_WXID');
    },
    clearRefreshChannel({ commit }) {
      commit('CLEAR_REFRESH_CHANNEL');
    },
    clearTfCardKey({ commit }) {
      commit('CLEAR_TF_CARD_KEY');
    },
    setUseWallet({ commit }, useWallet) {
      commit('SET_USE_WALLET', useWallet);
    },
    clearUseWallet({ commit }) {
      commit('CLEAR_USE_WALLET');
    },
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
